import {  useState } from "react";
import { MdArrowForward } from "react-icons/md";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import ForgotPassword from "./components/ForgotPassword";
import { API_BASE_URL } from "./api/Api";
import { useAuth } from "./context/AuthContext";
import axios from "axios";
import logo from './assets/adana.jpeg';

const LoginScreen = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [mobileNumber, setMobileNumber] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const navigate = useNavigate();
  const { login } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    console.log("🟡 Login submit started");

    if (!mobileNumber || !password) {
      setError("Mobile number and password are required");
      return;
    }

    try {
      setLoading(true);

      const res = await axios.post(`${API_BASE_URL}/api/auth/login`, {
        mobileNumber,
        password,
      });

      console.log("📥 Login API response:", res.data);

      if (res.data?.success) {
        const authPayload = {
          accessToken: res.data.data.accessToken,
          refreshToken: res.data.data.refreshToken,
          role: res.data.data.role,
          userId: res.data.data.user?.id,
        };

        console.log("🧾 Saving auth payload:", authPayload);

        login(authPayload);

        console.log("➡️ Navigating to dashboard");
        navigate("/dashboard", { replace: true });
      } else {
        setError(res.data?.message || "Login failed");
      }
    } catch (err) {
      console.error("❌ Login error:", err);
      setError(
        err.response?.data?.message || "Invalid mobile number or password"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    // Force light mode for entire login screen - Chrome dark mode won't affect it
    <div className="light-mode-force">
      <div className="bg-[#f8f9fc] text-[#0d121c] transition-colors">
        <div className="flex min-h-screen w-full font-display">

          {/* LEFT SIDE */}
          <div className="hidden lg:flex w-1/2 relative bg-grey overflow-hidden flex-col justify-between p-12">
            <div className="absolute inset-0 z-0 flex items-center justify-center">
              {/* Reduced image size */}
              <img
                src={logo}
                className="w-2/3 h-2/3 object-contain "
                alt="Adana Logo"
                style={{ maxWidth: "500px", maxHeight: "500px" }}
              />
              <div className="absolute inset-0"></div>
            </div>

           

            <div className="relative z-10 text-blue-200 text-sm">
              <p>© 2024 ADANA. All rights reserved.</p>
            </div>
          </div>

          {/* RIGHT SIDE */}
          <div className="w-full lg:w-1/2 flex flex-col justify-center items-center p-6 sm:p-12 lg:p-24 bg-[#ffffff]">
            <div className="w-full max-w-[420px] flex flex-col gap-8">
              {/* Mobile Logo */}
              <div className="lg:hidden flex justify-center">
                <div className="flex items-center gap-3">
                  <div className="size-10 bg-[#0d59f2] rounded-lg flex items-center justify-center">
                    <img
                      src={logo}
                      alt="Adana Logo"
                      className="w-6 h-6 object-contain invert"
                    />
                  </div>
                  <h2 className="text-xl font-bold text-[#0d121c]">ADANA</h2>
                </div>
              </div>

              <h1 className="text-3xl font-bold tracking-tight">
                Welcome to ADANA
              </h1>

              <form onSubmit={handleSubmit} className="flex flex-col gap-5">
                {/* Mobile */}
                <div className="flex flex-col gap-2">
                  <label className="text-sm font-semibold text-gray-700">
                    Mobile Number
                  </label>
                  <input
                    type="tel"
                    value={mobileNumber}
                    onChange={(e) => setMobileNumber(e.target.value)}
                    placeholder="Enter your phone number"
                    className="w-full h-12 rounded-xl border border-[#e7ebf4] bg-[#f8f9fc] px-4 focus:outline-none focus:ring-2 focus:ring-[#0d59f2]/30 focus:border-[#0d59f2]"
                  />
                </div>

                {/* Password */}
                <div className="flex flex-col gap-2">
                  <label className="text-sm font-semibold text-gray-700">
                    Password
                  </label>
                  <div className="relative">
                    <input
                      type={showPassword ? "text" : "password"}
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      placeholder="Enter your password"
                      className="w-full h-12 rounded-xl border border-[#e7ebf4] bg-[#f8f9fc] px-4 pr-12 focus:outline-none focus:ring-2 focus:ring-[#0d59f2]/30 focus:border-[#0d59f2]"
                    />
                    <button
                      type="button"
                      onClick={() => setShowPassword(!showPassword)}
                      className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700"
                    >
                      {showPassword ? <FaEyeSlash size={18} /> : <FaEye size={18} />}
                    </button>
                  </div>
                </div>

                {/* Error */}
                {error && (
                  <div className="p-3 rounded-lg bg-red-50 border border-red-200">
                    <p className="text-sm text-red-600 font-medium">{error}</p>
                  </div>
                )}

                {/* Remember / Forgot */}
                <div className="flex justify-between items-center">
                  <label className="flex items-center gap-2 cursor-pointer">
                    <input
                      type="checkbox"
                      className="w-4 h-4 rounded border-gray-300 text-[#0d59f2] focus:ring-[#0d59f2]/20"
                    />
                    <span className="text-sm text-gray-700">Remember me</span>
                  </label>

                  <button
                    type="button"
                    onClick={() => setShowPopup(true)}
                    className="text-[#0d59f2] text-sm font-medium hover:underline"
                  >
                    Forgot password?
                  </button>
                </div>

                {/* Submit */}
                <button
                  type="submit"
                  disabled={loading}
                  className="w-full h-12 bg-[#0d59f2] hover:bg-[#0a4bc8] text-white font-semibold rounded-xl flex items-center justify-center gap-2 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  {loading ? (
                    <>
                      <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                      Signing in...
                    </>
                  ) : (
                    <>
                      Sign In
                      <MdArrowForward size={20} />
                    </>
                  )}
                </button>
              </form>
            </div>
          </div>

          {showPopup && <ForgotPassword onClose={() => setShowPopup(false)} />}
        </div>
      </div>
    </div>
  );
};

export default LoginScreen;